import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Influencers from "../views/Influencers.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import Referral from "../views/Referral.vue";
import ReferralExtra from "../views/Referral_extra.vue";
import DashboardMember from "../views/DashboardMember.vue";
// import Users from "../views/Users.vue";
import User_Detail from "../views/User_Detail.vue";


import T2 from "../views/T2.vue";
import T3 from "../views/T3.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/Signin",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/dashboard-member",
    name: "dashboard/member",
    component: DashboardMember,
  },
  {
    path: "/tables",
    name: "Tables",
    component: Tables,
  },
  {
    path: "/user",
    name: "user",
    component: DashboardMember,
  },
  {
    path: "/user/:username",
    name: "user/detail",
    component: User_Detail,
  },
  
  {
    path: "/influencers",
    name: "Influencers",
    component: Influencers,
  },
  {
    path: "/billing",
    name: "Billing",
    component: Billing,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/referral",
    name: "Referral",
    component: Referral,
  },
  {
    path: "/referral_extra",
    name: "ReferralExtra",
    component: ReferralExtra,
  },
  {
    path: "/t2",
    name: "T2",
    component: T2,
  },
  {
    path: "/t3",
    name: "T3",
    component: T3,
  },
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
